/* eslint-disable react/button-has-type */
/* eslint-disable react/prop-types */
/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable react/no-children-prop */
import React, { SyntheticEvent, useEffect, useState } from 'react';
import {
  Box,
  Button,
  Container,
  CssBaseline,
  Grid,
  Modal,
  Typography,
} from '@mui/material';
import { toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';
import { useGoogleLogin } from '@react-oauth/google';

import useStyles from '../../assets/styles/pages/Login';
import FooterLogin from '../../components/FooterLogin';

// import svg
import { ReactComponent as IconEmail } from '../../assets/images/svg/login/icon_email.svg';
import { ReactComponent as IconPassword } from '../../assets/images/svg/login/icon_senha.svg';
import { ReactComponent as IconArrow } from '../../assets/images/svg/recover_password/icon_arrow.svg';
import { ReactComponent as IconNoUser } from '../../assets/images/svg/login/icon_no_user.svg';
import { ReactComponent as IconInfo } from '../../assets/images/svg/utils/info.svg';
import { ReactComponent as IconPhone } from '../../assets/images/svg/sign_up/icon_phone.svg';

import { ReactComponent as IconLoginGoogle } from '../../assets/images/svg/login/google-logo-fill.svg';
import { ReactComponent as IconLoginApple } from '../../assets/images/svg/login/apple-logo-fill.svg';

// import img
import imgLogo from '../../assets/images/svg/header/logo.png';
import FooterMenuMain from '../../components/FooterMenuMain';
import { useSignInContext } from '../../providers/use-signin';
import ForgotPassword from '../../components/ForgortPassword';
import { removeStorege } from '../../helpers/db_storage';

const styleModal = {
  position: 'absolute' as const,
  top: '100%',
  height: 850,
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  maxWidth: 680,
  borderRadius: 8,
  bgcolor: 'background.paper',
  border: '2px solid #ffffff',
  boxShadow: 24,
  p: '10px 25px',
  outline: 'none',
};

const SignIn: React.FC = () => {
  const { params, id_shop }: any = useParams();

  const classeStyle = useStyles();
  const { signing, signingGoogle, data, cleanData } = useSignInContext();
  const navigate = useNavigate();

  const [btnStyleSelectedLoginType, setBtnStyleSelectedLoginType] =
    useState('email');
  const [openUserNotFoud, setOpenUserNotFoud] = useState(false);
  const [openUserNotParams, setOpenUserNotParams] = useState(false);
  const [modalText, setModalText] = useState({
    title: '',
    description: '',
  });
  const [formSign, setFormSign] = useState({
    user_name: '',
    user_password: '',
    nrDDD: '',
    nrTelefone: '',
  });

  const handleToPage = (url: string) => {
    return navigate(url, { replace: true });
  };

  const handleChangeTypeLogin = (type: string) => {
    setBtnStyleSelectedLoginType(type);
  };

  const handleChangeForm = (event: any) => {
    const { name } = event.target;
    const { value } = event.target;

    setFormSign((field) => {
      return {
        ...field,
        [`${name}`]: value,
      };
    });
  };

  const handleSubimt = async (event: SyntheticEvent) => {
    event.preventDefault();

    if (btnStyleSelectedLoginType === 'email') {
      if (formSign.user_name === '' || formSign.user_password === '') {
        setModalText({
          title: 'Atenção',
          description: `Todas informações são obrigatorias`,
        });
        setOpenUserNotParams(true);
        return;
      }
    } else if (
      formSign.nrDDD === '' ||
      formSign.nrTelefone === '' ||
      formSign.user_password === ''
    ) {
      setModalText({
        title: 'Atenção',
        description: `Todas informações são obrigatorias`,
      });
      setOpenUserNotParams(true);
      return;
    }
    try {
      removeStorege('@mais/delivery/authorization/orders');
      if (params && id_shop) {
        removeStorege('@mais/delivery/shop/request/data/cart');
      }
      await signing({
        dsEmail: formSign.user_name,
        nrDDD: formSign.nrDDD,
        nrTelefone: formSign.nrTelefone,
        dsSenha: formSign.user_password,
        dsTipo: btnStyleSelectedLoginType,
      });
    } catch (error) {
      toast.error('Ocorreu um erro ao fazer login, tente novamente');
    }
  };

  const authGoogle = useGoogleLogin({
    onSuccess: async (codeResponse) => {
      try {
        await signingGoogle(codeResponse.code);
      } catch (error) {
        toast.error(
          'Ocorreu um erro ao fazer login pela Google, tente novamente',
        );
      }
    },
    flow: 'auth-code',
  });

  useEffect(() => {
    if (data.return === 'NOK' && data?.returnType === 'C') {
      setModalText({
        title: 'Atenção',
        description: data.msgError,
      });
      setOpenUserNotParams(true);
      return;
    }

    if (data?.returnType === 'C') {
      cleanData();
      handleToPage('/sign/up/user/phone');
      return;
    }

    if (data.return === 'NOK') {
      setOpenUserNotFoud(true);
    }

    if (data.return === 'OK' && params && id_shop) {
      toast.success('Login efetuado com sucesso, finalize seu pedido');
      handleToPage(`/shop/request/detail/${id_shop}`);
      return;
    }

    if (data.return === 'OK') {
      handleToPage('/');
    }
  }, [data]);

  return (
    <Container maxWidth={false} className={classeStyle.container}>
      <CssBaseline />
      <Grid
        container
        item
        justifyContent="center"
        alignItems="center"
        textAlign="center"
      >
        <Grid
          justifyContent="center"
          alignItems="center"
          container
          spacing={3}
          className={classeStyle.gridLogo}
        >
          <img src={imgLogo} alt="logo" className={classeStyle.logo} />
        </Grid>
        <Grid
          container
          item
          justifyContent="center"
          alignItems="center"
          textAlign="center"
          className={classeStyle.gridForm}
        >
          <h4 className={classeStyle.loginTitle}>Login</h4>
          <Grid>
            <Button
              onClick={() => handleChangeTypeLogin('email')}
              className={
                btnStyleSelectedLoginType === 'email'
                  ? classeStyle.btnLoginTypeSelected
                  : classeStyle.btnLoginType
              }
              variant="outlined"
            >
              E-mail
            </Button>
            <Button
              onClick={() => handleChangeTypeLogin('phone')}
              className={
                btnStyleSelectedLoginType === 'phone'
                  ? classeStyle.btnLoginTypeSelected
                  : classeStyle.btnLoginType
              }
              variant="outlined"
            >
              Celular
            </Button>
          </Grid>
          <form onSubmit={handleSubimt} className={classeStyle.form}>
            {btnStyleSelectedLoginType === 'email' ? (
              <Grid
                container
                item
                justifyContent="flex-start"
                alignItems="center"
                textAlign="center"
              >
                <IconEmail className={classeStyle.icon} />
                <input
                  type="text"
                  className={classeStyle.inputText}
                  placeholder="Preencha o seu E-mail"
                  name="user_name"
                  onChange={handleChangeForm}
                />
              </Grid>
            ) : (
              <Grid
                container
                item
                justifyContent="flex-start"
                alignItems="center"
                textAlign="center"
              >
                <IconPhone className={classeStyle.icon} />
                <Grid container item>
                  <Grid item xs={4} marginLeft="0px">
                    <input
                      type="text"
                      className={classeStyle.inputText}
                      placeholder="DDD"
                      value={formSign.nrDDD}
                      name="nrDDD"
                      size={3}
                      maxLength={3}
                      onChange={handleChangeForm}
                    />
                  </Grid>
                  <Grid item xs={8}>
                    <input
                      type="text"
                      className={classeStyle.inputText}
                      placeholder="+ Telefone"
                      size={9}
                      maxLength={9}
                      value={formSign.nrTelefone}
                      name="nrTelefone"
                      onChange={handleChangeForm}
                    />
                  </Grid>
                </Grid>
              </Grid>
            )}

            <Grid
              container
              item
              justifyContent="flex-start"
              alignItems="center"
              textAlign="center"
            >
              <IconPassword className={classeStyle.icon} />
              <input
                type="password"
                className={classeStyle.inputText}
                placeholder="Preencha a senha"
                name="user_password"
                onChange={handleChangeForm}
              />
            </Grid>
            <Button
              className={classeStyle.btnSubmit}
              type="submit"
              variant="contained"
            >
              Login
            </Button>
          </form>
          <Button
            onClick={() =>
              handleToPage(
                params && id_shop
                  ? `/sign/up/user/${params}/${id_shop}`
                  : '/sign/up/user',
              )
            }
            variant="outlined"
            className={classeStyle.btnCreateUser}
          >
            Criar uma conta
          </Button>
          <Grid item container xs={12} justifyContent="center">
            <hr className={classeStyle.hr} />
            <Grid className={classeStyle.socialLoginDividerContainer}>
              <h5 className={classeStyle.titleSocialLogin}>ou continuar com</h5>
            </Grid>
          </Grid>

          <Grid item container justifyContent="center">
            <Button onClick={() => authGoogle()}>
              <IconLoginGoogle />
            </Button>
          </Grid>
          <ForgotPassword />
        </Grid>
      </Grid>
      <FooterLogin />
      <FooterMenuMain />
      <Modal
        open={openUserNotFoud}
        onClose={() => setOpenUserNotFoud(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ ...styleModal, height: '640px!important' }}>
          <Grid container item xs={12} justifyContent="center">
            <IconNoUser className={classeStyle.iconModal} />
          </Grid>
          <Grid container item xs={12} justifyContent="center">
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              className={classeStyle.titleModal}
              style={{ fontWeight: '550' }}
            >
              Usuário não encontrado
            </Typography>
            <Typography
              id="modal-modal-description"
              sx={{ mt: 2 }}
              className={classeStyle.textModal}
            >
              Certifique que o usuário e senha estão corretos! Ou você pode
              realizar um cadastro gratúito agora mesmo!
            </Typography>
          </Grid>
          <Button
            className={classeStyle.btnSubmit}
            type="submit"
            variant="contained"
          >
            Criar uma conta
            <IconArrow className={classeStyle.iconArrow} />
          </Button>
          <Button
            color="secondary"
            onClick={() => setOpenUserNotFoud(false)}
            className={classeStyle.btnRecovePassword}
          >
            Tentar novamente
          </Button>
        </Box>
      </Modal>
      <Modal
        open={openUserNotParams}
        onClose={() => setOpenUserNotParams(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ ...styleModal, height: '500px!important' }}>
          <Grid container item xs={12} justifyContent="center">
            <IconInfo className={classeStyle.iconModal} />
          </Grid>
          <Grid container item xs={12} justifyContent="center">
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              className={classeStyle.titleModal}
              style={{ fontWeight: '550', width: '100%', textAlign: 'center' }}
            >
              {modalText.title}
            </Typography>
            <Typography
              id="modal-modal-description"
              sx={{ mt: 2 }}
              className={classeStyle.textModal}
            >
              {modalText.description}
            </Typography>
          </Grid>
          <Button
            className={classeStyle.btnSubmit}
            onClick={() => setOpenUserNotParams(false)}
            variant="contained"
          >
            Ok
          </Button>
        </Box>
      </Modal>
    </Container>
  );
};

export default SignIn;
